import { rem, rgba } from 'polished';

const size = {
  containerPaddingMobileSmall: 12,
  containerPaddingMobile: 16,
  containerPaddingTablet: 34,
  containerPaddingDesktop: 20,
  toolbarHeight: 60,
  cartPreviewWidth: 316,
  sidenavWidth: 260,
  sidenavWidthSmall: 210,
  takeoverInputfield: 60,
  checkoutBoxWidthTablet: 698,
  checkoutBoxWidthDesktop: 1032,
  cartPageMobileTotalsHeight: 120,
  onlineProductCardHeight: 392,
  onlineProductCardHeightMobile: 404,
  onlineProductCardHeightTablet: 430,
  offlineProductCardHeight: 308,
  offlineProductCardHeightMobile: 320,
  offlineProductCardHeightTablet: 333,
};

const colors = {
  // Colors - main
  primary: '#E60019',
  cherryRed: '#A80718',
  news: '#760133',
  plus: '#FFE500',
  eko: '#278648',
  highlight: '#0077B8',
  black: '#000000',
  lighterBlack: '#181818',
  darkerGray: '#767676',
  darkGray: '#949494',
  mediumGray: '#E2E0E2',
  lighterGray: '#F6F6F6',
  lightGray: '#EDEDED',
  white: '#FFFFFF',
  highlightBg: '#F2F9FD',

  // Colors - states
  primaryDark: '#CC0018',
  primaryInactive: '#FA969D',
  highlightHover: '#005D8D',
};

const fonts = {
  fontGothamBook: 'var(--font-gotham-book)',
  fontGothamMedium: 'var(--font-gotham-medium)',
  fontGothamSerifPrice: 'var(--font-gothamSerif-price)',
  fontGothamSerifBold: 'var(--font-gothamSerif-bold)',
};

const zIndex = {
  0: 0,
  1: 1,
  2: 2,
  scrollTop: 10,
  cart: 20,
  toolbar: 30,
  deliveryPicker: 40,
  mobileMenu: 50,
  cartPreview: 55,
  backdrop: 60,
  sideNav: 70,
  globalMessage: 80,
  modal: 90,
};

const animation = {
  normal: '250ms',
  slow: '1s',
  layout: '250ms',
};

const shadows = {
  top: `0 ${rem(6)} ${rem(10)} 0 ${rgba(colors.black, 0.08)}`,
  bottom: `0 -${rem(6)} ${rem(10)} 0 ${rgba(colors.black, 0.08)}`,
};

const variables = {
  colors,
  fonts,
  zIndex,
  animation,
  size,
  shadows,
};

export default variables;
